var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6685 0.885785C15.5623 0.778667 15.4359 0.693644 15.2966 0.635623C15.1573 0.577602 15.0079 0.547729 14.8571 0.547729C14.7062 0.547729 14.5568 0.577602 14.4176 0.635623C14.2783 0.693644 14.1519 0.778667 14.0456 0.885785L8.20564 6.72579C8.17899 6.75344 8.14704 6.77543 8.11169 6.79046C8.07635 6.80548 8.03833 6.81322 7.99993 6.81322C7.96152 6.81322 7.92351 6.80548 7.88817 6.79046C7.85282 6.77543 7.82087 6.75344 7.79422 6.72579L1.95422 0.885785C1.84797 0.778667 1.72157 0.693644 1.5823 0.635623C1.44304 0.577602 1.29366 0.547729 1.14279 0.547729C0.991916 0.547729 0.842538 0.577602 0.70327 0.635623C0.564003 0.693644 0.437601 0.778667 0.331358 0.885785C0.1185 1.09991 -0.000976562 1.38957 -0.000976562 1.6915C-0.000976562 1.99343 0.1185 2.28308 0.331358 2.49721L6.7885 8.95436C7.10993 9.27539 7.54564 9.45571 7.99993 9.45571C8.45422 9.45571 8.88993 9.27539 9.21136 8.95436L15.6685 2.49721C15.8814 2.28308 16.0008 1.99343 16.0008 1.6915C16.0008 1.38957 15.8814 1.09991 15.6685 0.885785Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron-down-icon.e055a4151b0d9b49ba65095fcba3fdd8.svg";
export { ForwardRef as ReactComponent };